import React, { useEffect, useState } from 'react';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { ReachSummary } from './reach_summary';

// Landing page for the "your paper's reach" emails, rendering the same snapshot
// the email did. Not wired into the AnalyticsDashboard Redux store: one
// endpoint, no shared state.
export const ReachTabContainer = () => {
  const [state, setState] = useState({ status: 'loading', reach: null });

  useEffect(() => {
    let cancelled = false;

    fetch(
      $r.reach_api_v0_user_stats_path({
        user_id: Aedu.User.viewed.id,
        subdomain_param: 'api',
      }),
      { credentials: 'same-origin', headers: { Accept: 'application/json' } },
    )
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((body) => {
        if (cancelled) return;
        setState({ status: 'loaded', reach: body.reach });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ status: 'error', reach: null });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (state.status === 'loading') {
    return (
      <div className="u-taCenter u-pv4x">
        <i className="fa fa-spin fa-spinner u-fs36"></i>
      </div>
    );
  }

  if (state.reach) {
    return <ReachSummary reach={state.reach} />;
  }

  // Distinct from the empty state: this is the email's landing page, and a
  // transient failure should not tell an author they have no reach.
  if (state.status === 'error') {
    return (
      <NoDataTab
        noUploadButton
        title="We couldn't load your reach just now."
        details="Something went wrong on our end. Please refresh the page to try again."
      />
    );
  }

  return (
    <NoDataTab
      noUploadButton
      title="We haven't measured your reach yet."
      details="Academia recommends papers to readers every day. Once we've recommended yours, this page will show how far it travelled."
    />
  );
};
